import { DeletePostDocument } from '@/graphql/generated/delete-post.generated';
import { useMutation } from '@apollo/client';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { usePosts } from '../../providers/PostsProvider';

const PostDeleteDialog = ({
    postId,
    children,
    open,
    onCancel,
    onDelete,
}: {
    postId: string | null;
    children: React.ReactNode;
    open: boolean;
    onCancel: () => void;
    onDelete?: () => void;
}) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const { removePost } = usePosts();

    const [deletePost, { loading: deleting }] = useMutation(DeletePostDocument, {
        onCompleted: ({ deletePost }) => {
            enqueueSnackbar(t('snackbar.content.deleted'));
            removePost(deletePost);
            onDelete?.();
        },
        onError: (e) => {
            enqueueSnackbar(e.message);
        },
    });

    if (!postId) {
        return null;
    }

    return (
        <>
            {children}
            <Dialog open={open} keepMounted>
                <DialogTitle>{t('content.delete.title')}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{t('content.delete.support-text')}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancel} disabled={deleting}>
                        {t('str.action.escape.cancel')}
                    </Button>
                    <Button onClick={() => deletePost({ variables: { postId } })} loading={deleting}>
                        {t('str.action.delete-permanently')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
export default PostDeleteDialog;
